// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetApiMessagesConversationsData, GetApiMessagesConversationsResponse, GetApiMessagesUnreadCountResponse, PostApiMessagesMarkReadData, PostApiMessagesMarkReadResponse, GetApiMessagesData, GetApiMessagesResponse, PostApiMessagesData, PostApiMessagesResponse } from './types.gen';

/**
 * Retrieve a list of conversations. This is used to populate the side of the chat window.
 * @param data The data for the request.
 * @param data.cursor Cursor for pagination
 * @param data.pageSize Number of conversations per page
 * @returns Conversation Successful retrieval of listings
 * @throws ApiError
 */
export const getApiMessagesConversations = (data: GetApiMessagesConversationsData = {}): CancelablePromise<GetApiMessagesConversationsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/messages/conversations',
        query: {
            cursor: data.cursor,
            pageSize: data.pageSize
        }
    });
};

/**
 * Get the number of conversations with unread messages for the authenticated user
 * @returns unknown Successful retrieval of unread conversation count
 * @throws ApiError
 */
export const getApiMessagesUnreadCount = (): CancelablePromise<GetApiMessagesUnreadCountResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/messages/unread-count'
    });
};

/**
 * Mark all messages from a specified conversation partner as read
 * @param data The data for the request.
 * @param data.requestBody Mark all messages from a conversation as read
 * @returns unknown Successfully marked messages as read
 * @throws ApiError
 */
export const postApiMessagesMarkRead = (data: PostApiMessagesMarkReadData): CancelablePromise<PostApiMessagesMarkReadResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/messages/mark-read',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Retrieve the messages in the conversation between the calling user and given user
 * @param data The data for the request.
 * @param data.otherUserId The id of the non calling user the conversation is with.
 * @param data.cursor Cursor for pagination
 * @param data.pageSize Number of messages per page
 * @param data.markAsRead Whether to mark retrieved messages as read
 * @returns Message Successful retrieval of listings
 * @throws ApiError
 */
export const getApiMessages = (data: GetApiMessagesData): CancelablePromise<GetApiMessagesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/messages',
        query: {
            otherUserId: data.otherUserId,
            cursor: data.cursor,
            pageSize: data.pageSize,
            markAsRead: data.markAsRead
        }
    });
};

/**
 * Send a new message in the conversation between the calling user and the given user
 * @param data The data for the request.
 * @param data.requestBody Message to be sent
 * @returns Message Successful sending of the message
 * @throws ApiError
 */
export const postApiMessages = (data: PostApiMessagesData): CancelablePromise<PostApiMessagesResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/messages',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Invalid input'
        }
    });
};